"use client";

import Link from "next/link";

import pom from "@/utils/pom";
import { applyDataTestId } from "@/utils/testUtils";
import { saveToSessionStorage } from "@/utils/sessionStorageUtils";
import { SessionStorageKey } from "@/utils/storageKeys";
import MenuItemContent from "@/components/menu/menuItemContent";
import { MenuItemProps } from "@/types/menus";

const MenuItem = ({ categoryId, item, itemTemplate, url, merchantName, markers, layout = "default", }: MenuItemProps) => (
  <Link
    id={`item-card-${item.id}-${categoryId}`}
    href={url}
    scroll={false}
    className="block h-full w-full"
    data-testid={applyDataTestId(pom.general.itemName)}
    prefetch={false}
    onClick={() => {
      saveToSessionStorage(
        SessionStorageKey.LAST_FOCUSED_ITEM_ID,
        `${item.id}-${categoryId}`
      );
    }}
  >
    <MenuItemContent
      item={item}
      merchantName={merchantName}
      itemTemplate={itemTemplate}
      layout={layout}
      markers={markers}
    />
  </Link>
);

export default MenuItem;
